<script setup>
import FordLogo from '@/components/FordLogo.vue';
import GenericModal from './GenericModal.vue';

const emit = defineEmits(['close']);

const close = () => emit('close');
</script>
<template>
  <generic-modal @close="close">
  <template v-slot:content>
    <div
      class="
        bg-ford-gray-light
        w-full tablet:max-w-[80rem]
        h-auto
      ">
      <div class="
        bg-ford-blue-dark tablet:h-[8rem] relative h-[6rem]
      ">
        <button
          @click="close"
          class="mx-[0.5rem] text-2xl text-white float-right"
        >&times;</button>
        <div class="text-white">
          <ford-logo
            number="2"
            class="
              tablet:w-[150px]
              w-[110px]
              left-[50%]
              top-[50%]
              translate-x-[-50%]
              translate-y-[-50%]
              absolute
            "
          />
        </div>
      </div>
      <slot name="body"></slot>
    </div>
  </template>
  </generic-modal>
</template>
